import { useQuery } from "@tanstack/react-query";
import { api } from "utils/api";
import { artistKeys } from "./queryKeys";
import type { ArtistsRequest, ArtistsResponse } from "../types";

const getCollectiveArtists = ({ collectiveId }: ArtistsRequest) =>
  collectiveId
    ? api.get<ArtistsResponse>(`/collective/${collectiveId}/artists`)
    : Promise.reject(new Error("Invalid collection id"));

const useCollectiveArtists = (collectiveId?: string) =>
  useQuery({
    queryKey: artistKeys.list({ collectiveId }),
    queryFn: () => getCollectiveArtists({ collectiveId }),
  });

export { useCollectiveArtists };
